import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Card from 'components/Card';
import CheckboxOption from 'components/CheckboxOption';
import EasyTooltip from 'components/EasyTooltip';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Table, { Column } from 'components/Table';
import TextLink from 'components/TextLink';
import Time from 'components/Time';
import getFullUserName from 'utils/getFullUserName';
import getUserInspectorLink from 'utils/getUserInspectorLink';
import { useFetchRecentPlaylistUsers } from 'actions/playlists';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TITLE_ID = 'user-progress-modal-title';
function UserProgressModal(_ref) {
  var id = _ref.id,
    name = _ref.name,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showOnlyInactiveUsers = _useState2[0],
    setShowOnlyInactiveUsers = _useState2[1];
  var _useFetchRecentPlayli = useFetchRecentPlaylistUsers({
      contentId: id,
      showOnlyInactiveUsers: showOnlyInactiveUsers
    }),
    items = _useFetchRecentPlayli.items,
    isLoading = _useFetchRecentPlayli.isLoading;
  return /*#__PURE__*/_jsx(Modal, {
    onRequestClose: onClose,
    "aria-labelledby": TITLE_ID,
    width: "extraWide",
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      overflow: "visible",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: t('analytics_user_progress'),
        titleId: TITLE_ID,
        subtitle: name,
        onClose: onClose
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(CheckboxOption, {
          label: t('modal_user_progress_checkbox'),
          description: t('modal_user_progress_hint'),
          checked: showOnlyInactiveUsers,
          onChange: function onChange(event) {
            return setShowOnlyInactiveUsers(event.target.checked);
          }
        })
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(Box, {
          mx: "-m",
          children: /*#__PURE__*/_jsxs(Table, {
            data: items,
            getItemKey: function getItemKey(item) {
              return "".concat(item.users.id, "-").concat(item.updated_time);
            },
            emptyContent: isLoading ? t('loading') : t('no_data_found'),
            pl: "m",
            pr: "xs",
            children: [/*#__PURE__*/_jsx(Column, {
              title: t('property_user_name'),
              cellRenderer: function cellRenderer(item) {
                var user = item.users;
                var name = getFullUserName(user) || user.name;
                var itemLink = getUserInspectorLink(user);
                return /*#__PURE__*/_jsx(EasyTooltip, {
                  content: name !== user.name ? user.name : null,
                  children: itemLink ? /*#__PURE__*/_jsx(TextLink, {
                    as: Link,
                    to: itemLink,
                    children: name
                  }) : name
                });
              }
            }), /*#__PURE__*/_jsx(Column, {
              title: t('property_progress'),
              cellRenderer: function cellRenderer(item) {
                return "".concat(Math.round(item.completionRate * 100), "%");
              },
              width: 1 / 4
            }), /*#__PURE__*/_jsx(Column, {
              title: t('property_last_active'),
              cellRenderer: function cellRenderer(item) {
                return /*#__PURE__*/_jsx(Time, {
                  dateTime: item.updated_time
                });
              },
              width: 1 / 4
            })]
          })
        })
      })]
    })
  });
}
export default UserProgressModal;